(function () {
    const select = (el, all = false) => {
        el = el.trim()
        if (all) {
            return [...document.querySelectorAll(el)]
        } else {
            return document.querySelector(el)
        }
    }

    "use strict";
    let rootnode = localStorage.getItem("root");
    let reference = rootnode + "#" + localStorage.getItem("caller");
    let ref_origin = localStorage.getItem("origin");
    let this_origin = window.location.origin;
    if (ref_origin == null || ref_origin != this_origin) {
        reference = rootnode + "#hero";
    }
    localStorage.removeItem("rootnode");
    localStorage.removeItem("caller");
    localStorage.removeItem("origin");

    let hits = 0;
    let navbarlinks = select('#navbar .scrollto', true);
    navbarlinks.forEach(navbarlink => {
        if (navbarlink.getAttribute("href") == reference) {
            navbarlink.classList.add('active');
            let hits = hits + 1;
        }
    });
    if (hits == 0) {
        let hero = document.getElementById("hero-navbar-button");
        if (hero != null) {
            hero.classList.add('active');
        }
    }
})()